import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=f27c63cc&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=f27c63cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27c63cc",
  null
  
)

export default component.exports